import { ClusteringBias } from "components/widgets/utility/ClusteringBias";

export type TopicTableSettingsStateType = {
  customWidgetTitle: string;
  density: string | undefined;
  rowStripes?: boolean;
  widgetTitle: string;
  widgetTitleAlignment: string;
  wordCount?: number;
  sortBy: string; 
  clusteringBias?: ClusteringBias;
}

export const topicTableDefaultSettings: TopicTableSettingsStateType = {
  customWidgetTitle: '',
  density: undefined,
  rowStripes: false,
  widgetTitle: 'none',
  widgetTitleAlignment: 'left',
  wordCount: undefined,
  sortBy: 'relevance',
  clusteringBias: ClusteringBias.Mid,
}